export const companyProfileFinancialsDefaultColDef = {
  autoWidth: true,
  width: 240,
  resizable: true,
  filter: false,
  enableRowGroup: true,
  suppressHeaderMenuButton: true,
  suppressHeaderFilterButton: true,
  cellStyle: {
    textAlign: 'right',
  },
  sortable: false,
};
